import { isNull, get } from "lodash"

const BOTTOM_LINE = 2
const TOP_LINE = 35
const BELOW_BOTTOM_LINE_MESSAGE = "The name is too-short or empty."
const ABOVE_TOP_LINE_MESSAGE = "The name is too long."

export const checkIsValidName = data => {
    return validateNameStep(get(data, ["name", "value"], "")) && !data.name.isValid
}

export const isFailureNameValidation = data => {
    return !validateNameStep(get(data, ["name", "value"], ""))
        && get(data, ["name", "validString"], "") !== getValidateNameMessage(get(data, ["name", "value"], ""))
}

export const validateNameStep = value => {
    return !isNull(value)
        ? value.length >= BOTTOM_LINE && value.length <= TOP_LINE
        : false
}

export const getValidateNameMessage = value => {
    let message = ""

    if (!isNull(value))
        if (value.length <= BOTTOM_LINE)
            message = BELOW_BOTTOM_LINE_MESSAGE
        else if (value.length >= TOP_LINE)
            message = ABOVE_TOP_LINE_MESSAGE

    return message
}